import { validateAccessToken } from '@data';
import { AddInError } from '@utils-global';

export const exchangeOBO = async (accessToken: string): Promise<string> => {
  if (!accessToken) throw new AddInError('Access token is not defined');
  const res = await validateAccessToken(accessToken);
  return res.graphToken;
};
